import Image from 'next/image';
import { PhoneCall, Star } from 'lucide-react';
import clsx from 'clsx';

// Helper to extract readable name from file path
const extractNameFromPath = (path) => {
  if (!path) return '';
  const name = path.split('/').pop().split('.')[0].replace(/[-_]/g, ' ');
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export default function Split({
  title,
  subtitle,
  background,
  description,
  extraText,
  phone,
  image1,
  image2,
  reverse = false,
}) {
  const image1Label = extractNameFromPath(image1);
  const image2Label = extractNameFromPath(image2);

  return (
    <section className={`pb-[100px] pt-[50px] px-4 bg-${background}`}>
      <div className={clsx("container mx-auto flex flex-col md:flex-row items-center gap-10", reverse && 'md:flex-row-reverse')}>
        {/* Content */}
        <div className="md:w-1/2 space-y-6">
          <span className="stars flex mb-5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 mr-2 fill-primary text-transparent" />
            ))}
          </span>
          <h2 className="uppercase tracking-[6px] text-lg text-gray font-light">{subtitle}</h2>
          <h3 className="text-4xl font-light text-black leading-tight font-gilda">{title}</h3>
          <p className="text-gray font-light text-lg leading-relaxed">{description}</p>
          {extraText && <p className="text-gray font-light text-lg leading-relaxed">{extraText}</p>}

          {phone && (
            <div className="flex items-center space-x-3 pt-4">
              <PhoneCall className="text-primary w-[40px] h-[40px]" />
              <div>
                <p className="text-sm text-gray capitalize">Free Consultation</p>
                <a href={`tel:+1${phone.replace(/[^0-9+]/g, '')}`} className="text-2xl font-light text-primary hover:underline">
                  {phone}
                </a>
              </div>
            </div>
          )}
        </div>

        {/* Images */}
        <div className="md:w-1/2 flex gap-2">
          {image1 && (
            <div className="w-1/2 overflow-hidden mt-[150px]">
              <Image
                src={image1}
                alt={image1Label}
                title={image1Label}
                width={255}
                height={340}
                className="h-auto object-cover"
                sizes="(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 175px"
              />
            </div>
          )}
          {image2 && (
            <div className="w-1/2 overflow-hidden mt-[50px]">
              <Image
                src={image2}
                alt={image2Label}
                title={image2Label}
                width={255}
                height={340}
                className="h-auto object-cover"
                sizes="(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 175px"
                quality={70}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
